import React from "react";

import { UserEntityForm, UserFormProps } from "Bands/components";
import { useProfileContext } from "Auth/contexts";
import { useValidateIssueExpiryDates, useCleanFileOnSubmit } from "Bands/utils";

import { getFormFields } from "./formData";
import { IUserDrivingPermitPatchData } from "Bands/types";

export const UserDrivingPermitForm: React.FC<UserFormProps> = ({
  defaultValues,
  handleSubmit,
  ...rest
}) => {
  const { currentUser } = useProfileContext();

  const {
    handleExpiryDateChange,
    handleFutureExpiryDateChange,
    handleIssueDateChange,
    isExpiryInFuture,
    isIssueBeforeExpiry,
  } = useValidateIssueExpiryDates(defaultValues?.issueDate, defaultValues?.expiryDate);

  const { onSubmit: onCleanFileSubmit } = useCleanFileOnSubmit({
    handleSubmit,
    userId: currentUser?.id,
    defaultFiles: defaultValues?.files,
  });

  const onSubmit = (data: IUserDrivingPermitPatchData) => {
    const cleanData: IUserDrivingPermitPatchData = {
      ...data,
      otherVehicleCategories: data?.otherVehicleCategories?.filter(category => !!category),
    };

    onCleanFileSubmit(cleanData);
  };

  return (
    <UserEntityForm
      defaultValues={defaultValues}
      handleSubmit={onSubmit}
      fields={getFormFields({
        isExpiryInFuture,
        isIssueBeforeExpiry,
        handleIssueDateChange,
        handleExpiryDateChange: date => {
          handleExpiryDateChange(date);
          handleFutureExpiryDateChange(date);
        },
      })}
      style={{
        gridTemplateColumns: "1fr 1fr",
      }}
      {...rest}
    />
  );
};
